import { Fragment } from 'react';

import cs from 'classnames';

import Icon from 'components/shared/Icon/Icon';

import { isLightIcon } from '../lib/helpers';

const IconGroup = ({ family, icons, category, onIconClick }) => {
  const copyFuncContent = (name) => {
    const copiedComponent = `<Icon icon='${name}' />`;
    return copiedComponent;
  };

  return (
    <div
      className={cs(
        'flex flex-col overflow-hidden rounded-2xl border border-solid border-neutral-200',
        (family === 'file' || family === 'cards-visuals') && 'col-span-full'
      )}>
      <div className="bg-secondary-100 p-2 text-center text-sm font-medium text-secondary-700">
        <span className="text-sm">{family}</span>
      </div>
      <div className="flex flex-row">
        {icons.map(({ name, type }) => (
          <Fragment key={`icon-${name}`}>
            <div
              className={cs(
                'group relative flex max-h-[150px] min-h-[150px] flex-1 cursor-pointer flex-col items-center justify-center overflow-hidden hover:bg-neutral-50',
                isLightIcon(name) ? 'bg-neutral-800' : 'bg-white'
              )}
              title="Copy"
              onClick={() => onIconClick(copyFuncContent(name))}>
              <Icon
                icon={name}
                id="icon-wrapper"
                className={cs(
                  'flex grow cursor-pointer justify-center',
                  category === '0'
                    ? 'size-10 min-h-10 min-w-10'
                    : 'min-h-size-24 min-w-size-24 size-24'
                )}
              />
              <div
                className={cs(
                  'w-full select-none border-0 border-t border-solid border-neutral-200 p-1 text-center text-sm ',
                  isLightIcon(name)
                    ? 'text-neutral-100 group-hover:bg-neutral-700'
                    : 'text-neutral-600 group-hover:bg-neutral-50'
                )}>
                {type}
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default IconGroup;
